import * as luxon from 'luxon';
import React, { useEffect } from 'react';

import styles from './MaintenancePage.module.scss';
import useMaintenance from './useMaintenance';
import NotFoundLayout from '../404Layout/NotFoundLayout';

const MaintenancePage = () => {
  const { estimatedDateActive, getMaintainStatus } = useMaintenance();

  useEffect(() => {
    getMaintainStatus();
  }, []);

  return (
    <NotFoundLayout>
      <section className={styles['notfound__container']}>
        <p className={styles['title']}>Maintenance underway</p>
        <div className={styles['desc-not-found']}>
          The website is undergoing a scheduled downtime for essential
          improvements. (Estimated downtime:{' '}
          {luxon.DateTime.fromSQL(estimatedDateActive).toFormat(
            'DD MMM yyyy HH:mm'
          )}
          )<span>Thank you for your understanding.</span>
        </div>
        <p className={styles['text-detail']}>More from us:</p>
        <div className={styles['button-wrapper']}>
          <button
            className={styles['button-back']}
            onClick={() =>
              window.location.replace(`${process.env.MYTHIC_PROTOCOL_URL}`)
            }
          >
            <p className={styles['button-text']}>Visit our Homepage</p>
          </button>
          <button
            className={styles['button-back']}
            onClick={() =>
              window.location.replace(`${process.env.MYTHIC_RIFTSTORM_URL}`)
            }
          >
            <p className={styles['button-text']}>Visit playriftstorm.com</p>
          </button>
        </div>
      </section>
    </NotFoundLayout>
  );
};

export default MaintenancePage;
